if(document.querySelectorAll(".block_product_promotion .block_card-offer-earn-info").length > 0) {

let productrewardpop = document.querySelector(".block_product_promotion .block_card-offer-earn-info");

productrewardpop.addEventListener("click", (event) => {
	document.querySelector("body").classList.add("popup-hidden");
	document.querySelector(".block_reward-pill-popup").classList.toggle("hidden");
});
let productPillClose = document.querySelector(".block_reward-pill-popup-inner .block_pill-pop-close-icon");

productPillClose.addEventListener("click", (event) => {
	document.querySelector("body").classList.remove("popup-hidden");
	document.querySelector(".block_reward-pill-popup").classList.toggle("hidden");
});


document.addEventListener('click', function(e) {
	var container = document.querySelector('.block_reward-pill-popup-inner');
	var container2 = document.querySelector('.block_card-offer-earn-info  ');
	var target = e.target;
	if (!container.contains(target) && !container2.contains(target)) {
		var isContainerClicked = target.classList.contains('block_card-offer-earn-info');
		var isDescendantClicked = container.contains(target);
		if (!isContainerClicked && !isDescendantClicked) {
			var kalviyoElements = document.querySelectorAll('.block_reward-pill-popup');
			kalviyoElements.forEach(function(element) {
				element.classList.add('hidden');
				document.querySelector("body").classList.remove("popup-hidden");
			});
		}
	}
});
}